import Title from 'src/refactor_components/common/Title';
import { ToggleButton } from '../common/ToggleButton';
import { useParams } from 'react-router-dom';

export const CurriculumType = () => {
  const { id } = useParams();

  return (
    <div className="flex flex-col gap-12 items-start">
      <Title essential text="수업 유형" />
      <div className="flex items-center gap-8">
        {CURRICULUM_TYPE.map(({ value, labelTitle, registerName }) => {
          return (
            <ToggleButton
              key={value}
              labelTitle={labelTitle}
              registerName={registerName}
              value={value}
              disabled={id ? true : false}
            />
          );
        })}
      </div>
    </div>
  );
};

const CURRICULUM_TYPE = [
  { registerName: 'curriculumType', value: '정규', labelTitle: '정규' },
  { registerName: 'curriculumType', value: '체험', labelTitle: '체험' },
  { registerName: 'curriculumType', value: '원포인트', labelTitle: '원포인트' }
];
